import { useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Modal, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { CreateThirdPartyInput, useCreateThirdPartyMutation } from '@/graphql/main';

type Props = {
    successCallback?: () => void;
};

const CreateTargetSkuModal = ({ successCallback }: Props) => {
    const [createThirdPartyMutation] = useCreateThirdPartyMutation();
    const [form] = Form.useForm<CreateThirdPartyInput>();
    const { t } = useTranslation('translation');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModalShow = () => {
        form.resetFields();
        setIsModalOpen(!isModalOpen);
    };

    const handleCreateTargetSku = async (values: CreateThirdPartyInput) => {
        try {
            await createThirdPartyMutation({
                variables: { input: { ...values } },
                onCompleted: () => {
                    successCallback?.();
                    message.success(t('CREATE_ITEM_SUCCESS'));
                },
                onError: () => message.error(t('CREATE_ITEM_FAIL'))
            });
            toggleModalShow();
        } catch {
            message.error(t('CREATE_ITEM_FAIL'));
        } finally {
            form.resetFields();
        }
    };

    return (
        <>
            <Row justify="end" style={{ marginTop: 18 }}>
                <Button type="primary" icon={<PlusOutlined />} onClick={toggleModalShow}>
                    {t('NEW_THIRD_PARTY')}
                </Button>
            </Row>
            <Modal
                title={t('CREATE_THIRD_PARTY')}
                open={isModalOpen}
                onCancel={toggleModalShow}
                footer={[
                    <Button key="back" onClick={toggleModalShow}>
                        {t('CANCEL')}
                    </Button>,
                    <Button key="submit" type="primary" onClick={() => form.submit()}>
                        {t('CREATE_THIRD_PARTY')}
                    </Button>
                ]}>
                <Form
                    form={form}
                    initialValues={{ isActive: true }}
                    onFinish={handleCreateTargetSku}>
                    <Form.Item
                        name="name"
                        label={t('NAME')}
                        labelCol={{ span: 24 }}
                        rules={[{ required: true, message: t('FIELD_REQUIRED') }]}>
                        <Input placeholder={t('NAME')} />
                    </Form.Item>
                    <Form.Item
                        name="sapNumber"
                        label={t('SAP_NUMBER')}
                        labelCol={{ span: 24 }}
                        rules={[{ required: true, message: t('FIELD_REQUIRED') }]}>
                        <Input placeholder={t('SAP_NUMBER')} />
                    </Form.Item>
                    <Form.Item
                        label={t('ACTIVE')}
                        name="isActive"
                        labelCol={{ span: 24 }}
                        rules={[{ required: true, message: t('ACTIVE_STATUS_REQUIRED') }]}>
                        <Select placeholder={t('ACTIVE')}>
                            <Select.Option value={true}>{t('YES')}</Select.Option>
                            <Select.Option value={false}>{t('NO')}</Select.Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default CreateTargetSkuModal;
